var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ geisha: true, zoomGesha: !_vm.enterGeisha }},[_c('img',{attrs:{"src":require("../assets/images/geisha.webp"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }